// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import Vuex from 'vuex'
import App from './App'
import VueRouter from 'vue-router'
import Route from './route'
import Meta from './meta'
import IView from './iView'

Vue.config.productionTip = false

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(Meta)
Vue.use(IView)

const store = new Vuex.Store({
  state: {
    user: false
  },
  mutations: {
    setUser(state, user) {
      console.warn('setUser', user);
      state.user = user
    },
    expired(state) {

    }
  }
})

const router = new VueRouter(Route)

// router.beforeEach((to, from, next) => {
//     console.warn('router to:', to)
//     router._current = to;
//     if (to.matched.length === 0) {
//         next({name:from.name})
//     } else if (to.meta.auth) {

//     }
// })

const main = new Vue({
  store,
  router,
  data: {
    enentHub: new Vue()
  },
  render: h => h(App)
}).$mount('#main')
console.warn('app inited')



// WEBPACK FOOTER //
// ./src/main.js